import { appAnalytics } from 'analytics';
import { ContinueWelcome, SaveAnswer } from 'analytics/AllEvents';
import { useAppDispatch } from 'bootstrap/hooks';
import { setAnswer } from 'bootstrap/onboarding/actions';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useFeatures } from 'useFeatures';
import { CustomQuestion } from 'onboarding/question/Question';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';

export const useCreoQuizComponentLogic = (question: CustomQuestion) => {
  const dispatch = useAppDispatch();

  const { id } = question;
  const [containerStyle, setContainerStyle] = useState('enter');

  const features = useFeatures();

  useEffect(() => {
    setContainerStyle('enter');
  }, []);

  const nextHandler = (e: SyntheticEvent, answer: string) => {
    e.preventDefault();

    if (question.id === QuestionIds.CreoQuizQ1) {
      appAnalytics.trackEvent(new ContinueWelcome('creo_quiz'));
    }

    appAnalytics.trackEvent(new SaveAnswer(id, answer));

    dispatch(setAnswer(id, answer, features));
  };

  return {
    containerStyle,
    nextHandler,
  };
};
